import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { alertError } from '@/utils/alertError';
import posthog from 'posthog-js';
import { POSTHOG_EVENT } from '@/services/posthog/events';

export async function forgotPassword(email: string) {
  try {
    posthog.capture(POSTHOG_EVENT.FORGOT_PASSWORD);
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    alertError(
      error,
      {
        function: 'forgotPassword',
        message: 'Failed to send forgot password email with Firebase.',
      },
      { email },
    );
    throw error;
  }
}
